import { useState, useEffect, useCallback } from 'react';

/**
 * @property 0 isDelayActive
 * @property 1 delayBy - specify that isDelayActive should return false for a period of time in ms.
 * after this interval, the component will rerender and isDelayActive will return true.
 */
type useDelayHook = [boolean, (delayMs: number) => void];

export default function useDelay(): useDelayHook {
  const [delayUntil, setDelayUntil] = useState(0);

  const delayBy = useCallback((delayMs: number) => {
    setDelayUntil(Date.now() + delayMs);
  }, []);

  useEffect(() => {
    if (!delayUntil) return;

    const intervalHandle = setTimeout(() => {
      setDelayUntil(0);
    }, delayUntil - Date.now());
    return () => clearInterval(intervalHandle);
  }, [delayUntil]);

  const delayIsActive = delayUntil !== 0;
  return [delayIsActive, delayBy];
}
